'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

export default function BookingWidget() {
  const [isHydrated, setIsHydrated] = useState(false);
  const [checkIn, setCheckIn] = useState('');
  const [checkOut, setCheckOut] = useState('');
  const [guests, setGuests] = useState(1);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    window.open('https://bookingengine.stayflexi.com/?hotel_id=33526', '_blank');
  };

  if (!isHydrated) {
    return (
      <div className="bg-white rounded-xl shadow-elevated p-6 border border-border">
        <div className="animate-pulse space-y-4">
          <div className="h-6 bg-gray-200 rounded w-3/4"></div>
          <div className="h-10 bg-gray-200 rounded"></div>
          <div className="h-10 bg-gray-200 rounded"></div>
          <div className="h-10 bg-gray-200 rounded"></div>
          <div className="h-12 bg-gray-200 rounded"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-elevated p-6 border border-border sticky top-24">
      <h3 className="font-display text-2xl font-semibold text-text-primary mb-6">Check Availability</h3>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-text-primary mb-2">Check-in Date</label>
          <input
            type="date"
            value={checkIn}
            onChange={(e) => setCheckIn(e.target.value)}
            className="w-full px-4 py-3 border border-border rounded-lg focus:ring-2 focus:ring-accent focus:border-transparent transition-all duration-300"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-text-primary mb-2">Check-out Date</label>
          <input
            type="date"
            value={checkOut}
            onChange={(e) => setCheckOut(e.target.value)}
            className="w-full px-4 py-3 border border-border rounded-lg focus:ring-2 focus:ring-accent focus:border-transparent transition-all duration-300"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-text-primary mb-2">Number of Guests</label>
          <select
            value={guests}
            onChange={(e) => setGuests(Number(e.target.value))}
            className="w-full px-4 py-3 border border-border rounded-lg focus:ring-2 focus:ring-accent focus:border-transparent transition-all duration-300"
          >
            {[1, 2, 3, 4, 5, 6].map((num) => (
              <option key={num} value={num}>{num} {num === 1 ? 'Guest' : 'Guests'}</option>
            ))}
          </select>
        </div>
        <button
          type="submit"
          className="w-full bg-accent hover:bg-accent/90 text-white font-semibold py-3 px-6 rounded-lg shadow-subtle hover:shadow-elevated transition-all duration-300 flex items-center justify-center space-x-2"
        >
          <span>Check Availability</span>
          <Icon name="ArrowRightIcon" size={20} />
        </button>
      </form>
      <div className="mt-6 pt-6 border-t border-border">
        <div className="flex items-center space-x-2 text-sm text-text-secondary mb-2">
          <Icon name="CheckCircleIcon" size={16} className="text-success" />
          <span>Free cancellation up to 24 hours</span>
        </div>
        <div className="flex items-center space-x-2 text-sm text-text-secondary">
          <Icon name="PhoneIcon" size={16} className="text-accent" />
          <span>24/7 Support: +91 98765 43210</span>
        </div>
      </div>
    </div>
  );
}